import { cardToContentCollectionCard } from "contentCollection/cardMapping";
import useEnteredViewport from "core/customHooks/useEnteredViewport";
import { Tracking } from "core/tracking";
import { config } from "core/utils";
import React from "react";
import { SeasonCollectionView } from "./SeasonCollectionView";
export var SeasonCollectionProvider = function (_a) {
    var componentId = _a.componentId, image = _a.image, vtmGoContent = _a.vtmGoContent, isPlus = _a.isPlus, listName = _a.listName, trackingEnabled = _a.trackingEnabled, programUuid = _a.programUuid, vtmgoUrl = _a.vtmgoUrl, className = _a.className;
    var _b = useEnteredViewport(config.tracking.impressionThreshold.default), ref = _b.ref, enteredViewport = _b.enteredViewport;
    if (trackingEnabled && enteredViewport && vtmGoContent) {
        Tracking.trackCollection(listName, vtmGoContent.episodeList);
    }
    var cards = vtmGoContent === null || vtmGoContent === void 0 ? void 0 : vtmGoContent.episodeList.map(function (episode) {
        return cardToContentCollectionCard(episode);
    });
    return (React.createElement(SeasonCollectionView, { componentId: componentId, image: image, items: cards, isPlus: isPlus, programUuid: programUuid, ref: ref, listName: listName, vtmgoUrl: vtmgoUrl, className: className }));
};
